/**
 * 商城产品管理组件
 * 
 * 提供积分商城的完整管理功能，包含四个子模块：
 * 1. 商品管理（mallValue=1）：商品的增删改查、排序、库存管理
 * 2. 订单管理（mallValue=2）：兑换订单的搜索、兑换确认、配送、删除
 * 3. Banner配置（mallValue=3）：商城Banner图片的上传与管理
 * 4. 积分配置（mallValue=4）：金额抵扣规则配置
 * 
 * @component
 * @requires points_goods - 商品列表接口
 * @requires points_goods_delete - 商品删除接口
 * @requires points_order_delete - 订单删除接口
 * @requires points_goods_infos - 商品详情接口
 * @requires points_goods_save - 商品保存接口
 * @requires points_goods_order - 兑换明细接口
 * @requires points_goods_sort - 商品排序接口
 * @requires points_order - 订单列表接口
 * @requires points_config - 积分配置接口
 * @requires points_config_banner - Banner配置接口
 * @requires points_config_save_config - 保存积分配置接口
 * @requires points_config_save_banner - 保存Banner接口
 * @requires points_order_status - 订单状态变更接口
 * @requires points_order_delivery - 订单配送接口
 * 
 * @event mallValueChange - 父组件通过事件总线切换子模块（值：1-商品 2-订单 3-Banner 4-配置）
 * 
 * @data imgtype {number} 图片库类型标识（1-Banner图 2-封面图 3-商品图）
 * @data switch_modal {boolean} 图片库弹窗开关
 * @data storePrams {Object} 商品列表分页参数（page, limit）
 * @data storePramsOrder {Object} 订单列表分页与筛选参数（page, limit, status, pickup_type, keywords）
 * @data formData {Object} 商品表单数据（含名称、图片、购买方式、积分、库存等）
 * @data configData {Object} 积分抵扣配置数据（amount_deduction, amount, amount_points, rate）
 * @data bannerData {Object} Banner图片数据（banner, show_banner, banner_array）
 * @data deliveryData {Object} 配送信息数据（id, delivery_info）
 * @data mallValue {string} 当前子模块标识
 * @data drawers {boolean} 商品编辑抽屉开关
 * @data countDrawer {boolean} 兑换明细弹窗开关
 * @data deliveryModal {boolean} 配送信息弹窗开关
 */
<template>
    <div class="container">
        <div v-if="mallValue == 1" class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goDrawer"
                    >新增商城产品</Button
                >
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="stock">
                        <div v-if="row.able_stock == 1">{{ row.stock }}</div>
                        <div v-else>无限制</div>
                    </template>
                    <template slot-scope="{ row }" slot="order_count">
                        <Button @click="goCount(row)">{{
                            row.order_count
                        }}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost @click="goDrawer(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page-container">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="goChangePage"
                />
            </div>
        </div>
        <div v-else-if="mallValue == 2">
            <div class="header">
                <Input
                    class="w300 mr24 mb24"
                    type="text"
                    v-model="storePramsOrder.keywords"
                    placeholder="搜索会员名称、手机号、兑换码"
                ></Input>
                <Select
                    class="w100 mr24 mb24"
                    v-model="storePramsOrder.pickup_type"
                    clearable
                    filterable
                    placeholder="全部"
                >
                    <Option
                        v-for="item in typeList"
                        :value="item.id"
                        :key="item.id"
                        >{{ item.name }}</Option
                    >
                </Select>
                <Select
                    class="w100 mr24 mb24"
                    v-model="storePramsOrder.status"
                    clearable
                    filterable
                    placeholder="全部"
                >
                    <Option
                        v-for="item in statusList"
                        :value="item.id"
                        :key="item.id"
                        >{{ item.name }}</Option
                    >
                </Select>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="ios-search"
                    @click="goSearchOrder"
                    >确认搜索</Button
                >
            </div>
            <div class="content">
                <Table
                    :columns="columnsTableOrder"
                    :data="dataTableOrder"
                    border
                >
                    <template slot-scope="{ row }" slot="goods">
                        <div>{{ row.goods ? row.goods.name : "" }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="show_status">
                        <div>{{ row.show_status }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="show_pickup_type">
                        <Button
                            v-if="row.pickup_type == 2"
                            type="success"
                            ghost
                            @click="goDelivery(row)"
                            >{{ row.show_pickup_type }}</Button
                        >
                        <div v-else>{{ row.show_pickup_type }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div v-if="row.status != 2" class="flex-sa">
                            <!-- <Button
                                v-if="
                                    row.pay_status == 1 &&
                                    row.status == 1 &&
                                    row.pickup_type == 2
                                "
                                type="success"
                                ghost
                                @click="goDelivery(row)"
                                >配送</Button
                            > -->
                            <!-- <Button
                                v-else-if="
                                    row.pay_status == 1 &&
                                    row.status == 1 &&
                                    row.pickup_type == 1
                                "
                                type="success"
                                ghost
                                @click="goExchange(row)"
                                >兑换</Button
                            > -->
                            <Button type="error" ghost @click="goDel(2, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page-container">
                    <Page
                        :current="storePramsOrder.page"
                        :page-size="storePramsOrder.limit"
                        :total="totalOrder"
                        show-elevator
                        show-total
                        @on-change="goChangePageOrder"
                    />
                </div>
            </div>
        </div>
        <div v-else-if="mallValue == 3" class="content">
            <Form :model="bannerData" label-position="right" :label-width="150">
                <FormItem label="banner图片：">
                    <div class="dis-flex">
                        <div class="form-upload mr12" @click="openModal(1)">
                            <Icon type="ios-add" size="44" color="#AEAEB3" />
                            <div>415px*300px</div>
                        </div>
                        <div v-for="(e, i) in bannerData.show_banner" :key="i">
                            <div class="upload-container">
                                <Icon
                                    class="upload-del"
                                    size="20"
                                    type="ios-close-circle"
                                    color="#f00"
                                    @click="goDelShowBanner(i)"
                                />
                                <img class="upload-img" :src="e" />
                            </div>
                        </div>
                    </div>
                </FormItem>
                <div class="footer">
                    <Button
                        class="theme-bc theme-default-color"
                        @click="goSubmitBanner"
                        >确定</Button
                    >
                </div>
            </Form>
        </div>
        <div v-else-if="mallValue == 4" class="content">
            <Form :model="configData" label-position="right" :label-width="150">
                <FormItem label="金额抵扣: ">
                    <i-switch
                        v-model="configData.amount_deduction"
                        size="large"
                        true-color="#FF761D"
                        :true-value="1"
                        :false-value="0"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                    <template v-if="configData.amount_deduction == 1">
                        <div
                            class="mt24 mb24"
                            style="display: flex; align-items: center"
                        >
                            <Input
                                class="w200"
                                type="text"
                                v-model="configData.amount"
                                placeholder="请输入"
                                ><span slot="append">元</span></Input
                            >
                            <div class="mr24 ml24">等于</div>
                            <Input
                                class="w200"
                                type="text"
                                v-model="configData.amount_points"
                                placeholder="请输入"
                                ><span slot="append">积分</span></Input
                            >
                        </div>
                        <div style="display: flex; align-items: center">
                            <div class="mr24">最高抵扣当前订单的</div>
                            <Input
                                class="w200"
                                type="text"
                                v-model="configData.rate"
                                placeholder="请输入"
                                ><span slot="append">%</span></Input
                            >
                        </div>
                    </template>
                </FormItem>
                <div class="footer">
                    <Button
                        class="theme-bc theme-default-color"
                        @click="goSubmitConfig"
                        >确定</Button
                    >
                </div>
            </Form>
        </div>
        <Drawer v-model="drawers" :title="drawerTitle" width="80">
            <Form :model="formData" label-position="right" :label-width="150">
                <div class="form-title">商品详情</div>
                <FormItem label="商品名：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.name"
                        placeholder="请输入商品名"
                    ></Input>
                </FormItem>
                <FormItem label="排序：">
                    <Input
                        class="w300"
                        type="number"
                        v-model="formData.sort"
                        placeholder="请输入排序"
                    ></Input>
                </FormItem>
                <FormItem label="封面图: ">
                    <div class="dis-flex">
                        <div class="form-upload mr12" @click="openModal(2)">
                            <Icon type="ios-add" size="44" color="#AEAEB3" />
                            <div>320px*280px</div>
                        </div>
                        <div v-if="formData.show_img" class="form-img">
                            <img class="wh100" :src="formData.show_img" />
                            <Icon
                                class="upload-del"
                                size="20"
                                type="ios-close-circle"
                                color="#f00"
                                @click="goDelImg"
                            />
                        </div>
                    </div>
                </FormItem>
                <FormItem label="商品图: ">
                    <div class="dis-flex">
                        <div class="form-upload mr12" @click="openModal(3)">
                            <Icon type="ios-add" size="44" color="#AEAEB3" />
                            <div>690px*320px</div>
                        </div>
                        <div v-for="(e, i) in formData.show_banner" :key="i">
                            <div class="upload-container">
                                <Icon
                                    class="upload-del"
                                    size="20"
                                    type="ios-close-circle"
                                    color="#f00"
                                    @click="goDelBanner(i)"
                                />
                                <img class="upload-img" :src="e" />
                            </div>
                        </div>
                    </div>
                </FormItem>
                <!-- <FormItem label="购买方式: ">
                    <CheckboxGroup
                        v-model="formData.buy_type"
                        @on-change="goChangeBuyType"
                    >
                        <Checkbox
                            style="margin-right: 24px"
                            label="积分"
                        ></Checkbox>
                        <Checkbox label="线上支付"></Checkbox>
                    </CheckboxGroup>
                    <template
                        v-if="
                            formData.buy_type_value.includes('1') &&
                            formData.buy_type_value.includes('2') &&
                            !configData.amount_deduction
                        "
                    >
                        <div
                            style="
                                padding: 6px 12px;
                                width: 555px;
                                border: 1px dashed #ccc;
                            "
                        >
                            <div class="flex-center">
                                <div style="width: 66px">金额抵扣:</div>
                                <i-switch
                                    v-model="configData.amount_deduction"
                                    size="large"
                                    true-color="#FF761D"
                                    :true-value="1"
                                    :false-value="0"
                                >
                                    <span slot="open">开启</span>
                                    <span slot="close">关闭</span>
                                </i-switch>
                            </div>
                            <template v-if="configData.amount_deduction">
                                <div
                                    class="mt24 mb24 flex-center"
                                    style="margin-left: 66px"
                                >
                                    <Input
                                        class="w200"
                                        type="number"
                                        v-model="configData.amount"
                                        placeholder="请输入"
                                        ><span slot="append">元</span>
                                    </Input>
                                    <div class="ml12 mr12">等于</div>
                                    <Input
                                        class="w200"
                                        type="number"
                                        v-model="configData.amount_points"
                                        placeholder="请输入"
                                        ><span slot="append">积分</span></Input
                                    >
                                </div>
                                <div
                                    class="flex-center"
                                    style="margin-left: 66px"
                                >
                                    <div class="mr12">最高抵扣当前订单的</div>
                                    <Input
                                        class="w200"
                                        type="number"
                                        v-model="configData.rate"
                                        placeholder="请输入"
                                        ><span slot="append">%</span></Input
                                    >
                                </div>
                            </template>
                        </div>
                    </template>
                </FormItem> -->
                <FormItem
                    label="所需积分: "
                >
                    <Input
                        class="w300"
                        type="number"
                        v-model="formData.points"
                        placeholder="请输入积分"
                    ></Input>
                </FormItem>
                <!-- <FormItem
                    v-if="formData.buy_type_value.includes('2')"
                    label="所需金额: "
                >
                    <Input
                        class="w300"
                        type="number"
                        v-model="formData.money"
                        placeholder="请输入金额"
                    ></Input>
                </FormItem> -->
                <FormItem label="提取方式: ">
                    <RadioGroup v-model="formData.pickup_type">
                        <!-- <Radio class="mr24" label="1">自提</Radio> -->
                        <Radio label="2">快递</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="兑换限制: ">
                    <RadioGroup v-model="formData.ex_restrictions">
                        <Radio class="mr24" label="1">无限制</Radio>
                        <Radio class="mr24" label="2">每人只可兑换一次</Radio>
                        <Radio label="3">每人每天可兑换一次</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="库存启用: ">
                    <i-switch
                        v-model="formData.able_stock"
                        size="large"
                        true-color="#FF761D"
                        :true-value="1"
                        :false-value="0"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem v-if="formData.able_stock == 1" label="库存数量: ">
                    <Input
                        class="w300"
                        type="number"
                        v-model="formData.stock"
                        placeholder="请输入库存数量"
                    ></Input>
                </FormItem>
                <FormItem label="商品详情: ">
                    <editor
                        style="width: 555px"
                        :edtor-con="formData.content"
                        :index="1"
                        @getContent="getEnContent1"
                        @getContentchange="getEnContentchange1"
                    />
                </FormItem>
                <div class="footer">
                    <Button @click="goCancelForm">取消</Button>
                    <Button
                        class="theme-bc ml24 theme-default-color"
                        @click="goSubmitForm"
                        >确定</Button
                    >
                </div>
            </Form>
        </Drawer>
        <Modal
            v-model="countDrawer"
            title="兑换明细"
            width="80"
            :mask-closable="false"
        >
            <Table :columns="columnCount" :data="dataCount" border>
                <template slot-scope="{ row }" slot="goods">
                    <div>{{ row.goods ? row.goods.name : "" }}</div>
                </template>
            </Table>
            <div class="page-container">
                <Page
                    :current="pageCount.page"
                    :page-size="pageCount.limit"
                    :total="totalCount"
                    show-elevator
                    show-total
                    @on-change="goChangePageCount"
                />
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 配送信息 -->
        <Modal
            v-model="deliveryModal"
            title="配送信息"
            width="555"
            :mask-closable="false"
        >
            <Form
                :model="deliveryData"
                label-position="right"
                :label-width="100"
            >
                <FormItem label="收货人：">
                    <div>{{ deliveryData.name }}</div>
                </FormItem>
                <FormItem label="联系方式：">
                    <div>{{ deliveryData.phone }}</div>
                </FormItem>
                <FormItem label="收货地址：">
                    <div>{{ deliveryData.address }}</div>
                </FormItem>
                <FormItem label="配送信息：">
                    <Input
                        type="textarea"
                        v-model="deliveryData.delivery_info"
                        placeholder="请输入配送信息"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="goCancelDelivery">取消</Button>
                <Button
                    class="theme-bc ml24 theme-default-color"
                    @click="goSubmitDelivery"
                    >确定</Button
                >
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    points_goods,
    points_goods_delete,
    points_order_delete,
    points_goods_infos,
    points_goods_save,
    points_goods_order,
    points_goods_sort,
    points_order,
    points_config,
    points_config_banner,
    points_config_save_config,
    points_config_save_banner,
    points_order_status,
    points_order_delivery,
    points_order_info,
} from "@/api/index";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";
export default {
    components: { pictureLibrary, editor },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "排序", key: "sort", align: "center" },
                { title: "商品名", key: "name", align: "center" },
                {
                    title: "积分",
                    key: "points",
                    align: "center",
                },
                {
                    title: "提取方式",
                    key: "show_pickup_type",
                    align: "center",
                },
                {
                    title: "库存数量",
                    slot: "stock",
                    align: "center",
                },
                {
                    title: "已兑换数量",
                    slot: "order_count",
                    align: "center",
                },
                // {
                //     title: "金额",
                //     key: "money",
                //     align: "center",
                // },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            storePramsOrder: {
                page: 1,
                limit: 10,
                status: -1,
                pickup_type: -1,
            },
            totalOrder: 0,
            columnsTableOrder: [
                { type: "index", width: 60, align: "center" },
                { title: "商品名", slot: "goods", align: "center" },
                {
                    title: "会员名",
                    key: "name",
                    align: "center",
                },
                {
                    title: "手机号",
                    key: "phone",
                    align: "center",
                },
                {
                    title: "兑换码",
                    key: "redemption_code",
                    align: "center",
                },
                {
                    title: "状态",
                    slot: "show_status",
                    align: "center",
                },
                {
                    title: "提取方式",
                    slot: "show_pickup_type",
                    align: "center",
                },
                {
                    title: "取货时间",
                    key: "created_at",
                    align: "center",
                },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTableOrder: [],
            drawers: false,
            drawerTitle: "",
            formData: {
                id: "",
                name: "",
                sort: "",
                img: "",
                banner: "",
                buy_type: ["积分"],
                points: "",
                money: "0",
                pickup_type: "2",
                ex_restrictions: "1",
                able_stock: 0,
                stock: "",
                content: "",
                amount_deduction: 0,
                amount: "1",
                rate: "100",
                amount_points: "1",
                buy_type_value: [],
                show_img: "",
                show_banner: [],
                banner_array: [],
            },
            countDrawer: false,
            pageCount: {
                page: 1,
                limit: 10,
                goods_id: "",
                pay_status: 1,
            },
            totalCount: 0,
            columnCount: [
                { type: "index", title: "排序", width: 100, align: "center" },
                { title: "商品名称", slot: "goods", align: "center" },
                { title: "用户名称", key: "name", align: "center" },
                { title: "手机号", key: "phone", align: "center" },
                { title: "兑换码", key: "redemption_code", align: "center" },
                { title: "状态", key: "show_status", align: "center" },
                { title: "提货方式", key: "show_pickup_type", align: "center" },
            ],
            dataCount: [],
            mallValue: "1",
            typeList: [
                { id: -1, name: "全部" },
                { id: 1, name: "自提" },
                { id: 2, name: "快递" },
            ],
            statusList: [
                { id: -1, name: "全部" },
                { id: 1, name: "未兑换" },
                { id: 2, name: "已兑换" },
            ],
            configData: {
                amount_deduction: 0,
                amount: "1",
                amount_points: "1",
                rate: "100",
            },
            bannerData: {
                banner: "",
                show_banner: [],
                banner_array: [],
            },
            deliveryData: {
                id: "",
                delivery_info: "",
                name: "",
                phone: "",
                address: "",
            },
            deliveryModal: false,
        };
    },

    // 缓存页面激活时（解决你退出再回来的问题）
    activated() {
        this.mallValue = 1;
        if (this.mallValue == 1) {
            this.getList();
        } else if (this.mallValue == 2) {
            this.getListOrder();
        } else if (this.mallValue == 3) {
            this.getPointsConfigBanner();
        } else if (this.mallValue == 4) {
            this.getPointsConfig();
        }
    },

    mounted() {
        // 同步父页面当前值
        this.mallValue = 1;
        this.getPointsConfig();

        // 监听事件
        this.handleMallChange = (val) => {
            this.mallValue = val;
            if (val == 1) {
                this.getList();
            } else if (val == 2) {
                this.getListOrder();
            } else if (val == 3) {
                this.getPointsConfigBanner();
            } else if (val == 4) {
                this.getPointsConfig();
            }
        };
        this.$bus.$on("mallValueChange", this.handleMallChange);

        // 初始化执行
        if (this.mallValue == 1) {
            this.getList();
        } else if (this.mallValue == 2) {
            this.getListOrder();
        } else if (this.mallValue == 3) {
            this.getPointsConfigBanner();
        } else if (this.mallValue == 4) {
            this.getPointsConfig();
        }
    },

    beforeDestroy() {
        this.$bus.$off("mallValueChange", this.handleMallChange);
    },

    methods: {
        // 获取配置
        getPointsConfig() {
            points_config()
                .then((res) => {
                    if (res.data) {
                        this.configData.amount_deduction = res.data
                            .amount_deduction
                            ? res.data.amount_deduction
                            : 0;
                        this.configData.amount = res.data.amount
                            ? res.data.amount
                            : "1";
                        this.configData.amount_points = res.data.amount_points
                            ? res.data.amount_points
                            : "1";
                        this.configData.rate = res.data.rate
                            ? res.data.rate
                            : "100";
                    } else {
                        this.configData.amount_deduction = 0;
                        this.configData.amount = "1";
                        this.configData.amount_points = "1";
                        this.configData.rate = "100";
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 获取banner
        getPointsConfigBanner() {
            points_config_banner()
                .then((res) => {
                    this.bannerData.banner = res.data.banner;
                    if (res.data.banner) {
                        var banner = res.data.banner;
                        this.bannerData.banner_array = banner.split(",");
                    } else {
                        this.bannerData.banner_array = [];
                    }
                    this.bannerData.show_banner = res.data.show_banner
                        ? res.data.show_banner
                        : [];
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.bannerData.show_banner.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.bannerData.banner_array.push(param2[i]);
                }
                this.$Message.destroy();
            } else if (this.imgtype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_img = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.img = param2[i];
                }
                this.$Message.destroy();
            } else if (this.imgtype == 3) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_banner.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.banner_array.push(param2[i]);
                }
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList() {
            points_goods(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goChangePage(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearchOrder() {
            this.storePramsOrder.page = 1;
            this.getListOrder();
        },
        getListOrder() {
            points_order(this.storePramsOrder)
                .then((res) => {
                    this.dataTableOrder = res.data.data;
                    this.totalOrder = res.data.total;
                    if (
                        !res.data.data.length &&
                        this.storePramsOrder.page != 1
                    ) {
                        this.storePramsOrder.page--;
                        this.getListOrder();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goChangePageOrder(index) {
            this.storePramsOrder.page = index;
            this.getListOrder();
        },
        goDrawer(row) {
            if (row.id) {
                this.drawerTitle = "编辑商城产品";
                this.getInfo(row.id);
            } else {
                this.drawerTitle = "新增商城产品";
                this.formData.id = "";
                this.formData.name = "";
                this.formData.img = "";
                this.formData.banner = "";
                this.formData.buy_type = ["积分"];
                this.formData.points = "";
                this.formData.money = "0";
                this.formData.pickup_type = "2";
                this.formData.ex_restrictions = "1";
                this.formData.able_stock = 0;
                this.formData.stock = "";
                this.formData.content = "";
                this.formData.buy_type_value = [];
                this.formData.show_img = "";
                this.formData.show_banner = [];
                this.formData.banner_array = [];
                this.getSort();
            }
            setTimeout(() => {
                this.drawers = true;
            }, 300);
        },
        getSort() {
            points_goods_sort()
                .then((res) => {
                    this.formData.sort = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getInfo(id) {
            points_goods_infos({ id: id })
                .then((res) => {
                    this.formData.id = res.data.id;
                    this.formData.name = res.data.name;
                    this.formData.sort = res.data.sort;
                    this.formData.img = res.data.img;
                    this.formData.banner = res.data.banner;
                    if (res.data.banner) {
                        var banner = res.data.banner;
                        this.formData.banner_array = banner.split(",");
                    } else {
                        this.formData.banner_array = [];
                    }
                    this.formData.buy_type_value = res.data.buy_type;
                    this.formData.points = res.data.points;
                    // this.formData.money = res.data.money;
                    this.formData.money = "0";
                    this.formData.pickup_type = res.data.pickup_type;
                    this.formData.ex_restrictions =
                        res.data.ex_restrictions + "";
                    this.formData.able_stock = res.data.able_stock;
                    this.formData.stock = res.data.stock;
                    this.formData.content = res.data.content;
                    this.formData.show_img = res.data.show_img;
                    this.formData.show_banner = res.data.show_banner;
                    this.formData.buy_type = this.formData.buy_type_value.map(
                        (item) => {
                            if (item === "1") return "积分";
                            if (item === "2") return "线上支付";
                            return item;
                        }
                    );
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goCancelForm() {
            this.drawers = false;
        },
        goSubmitForm() {
            const buyTypeArr = this.formData.buy_type || [];
            if (buyTypeArr.length === 0) {
                this.$Message.error("请至少选择一种支付方式");
                return;
            }
            if (buyTypeArr.length === 1 && buyTypeArr[0] === "线上支付") {
                this.$Message.error(
                    "不能只选择线上支付，请至少选择其他支付方式"
                );
                return;
            }
            this.formData.buy_type_value = this.formData.buy_type.map(
                (item) => {
                    if (item === "积分") return "1";
                    if (item === "线上支付") return "2";
                    return item;
                }
            );
            this.formData.banner = this.formData.banner_array.join(",");
            const data = {
                id: this.formData.id,
                name: this.formData.name,
                sort: this.formData.sort,
                img: this.formData.img,
                banner: this.formData.banner,
                buy_type: this.formData.buy_type_value,
                points: this.formData.points,
                money: this.formData.money,
                pickup_type: this.formData.pickup_type,
                ex_restrictions: this.formData.ex_restrictions + "",
                able_stock: this.formData.able_stock,
                stock: this.formData.stock,
                content: this.formData.content,
                amount_deduction: this.configData.amount_deduction,
                amount: this.configData.amount,
                rate: this.configData.rate,
                amount_points: this.configData.amount_points,
            };
            points_goods_save(data)
                .then((res) => {
                    this.getList();
                    this.getListOrder();
                    this.drawers = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goDel(index, row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 1) {
                        points_goods_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 2) {
                        points_order_delete({ id: row.id })
                            .then((res) => {
                                this.getListOrder();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        getAssemblyWxpacketPrize() {
            points_goods_order(this.pageCount)
                .then((res) => {
                    this.dataCount = res.data.data;
                    this.totalCount = res.data.total;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goChangePageCount(index) {
            this.pageCount.page = index;
            this.getAssemblyWxpacketPrize();
        },
        goCount(row) {
            this.pageCount.goods_id = row.id;
            this.getAssemblyWxpacketPrize();
            this.countDrawer = true;
        },
        goDelImg() {
            this.formData.show_img = "";
            this.formData.img = "";
        },
        goDelBanner(i) {
            this.formData.banner_array.splice(i, 1);
            this.formData.show_banner.splice(i, 1);
        },
        goDelShowBanner(i) {
            this.bannerData.banner_array.splice(i, 1);
            this.bannerData.show_banner.splice(i, 1);
        },
        goChangeBuyType() {
            this.formData.buy_type_value = this.formData.buy_type.map(
                (item) => {
                    if (item === "积分") return "1";
                    if (item === "线上支付") return "2";
                    return item;
                }
            );
        },
        getEnContentchange1(detailData) {
            this.formData.content = detailData.editorData;
        },
        getEnContent1(detailData) {
            this.formData.content = detailData.editorData;
        },
        goSubmitBanner() {
            this.bannerData.banner = this.bannerData.banner_array.join(",");
            var data = {
                banner: this.bannerData.banner,
            };
            points_config_save_banner(data)
                .then((res) => {
                    this.getPointsConfigBanner();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goSubmitConfig() {
            points_config_save_config(this.configData)
                .then((res) => {
                    this.getPointsConfig();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goExchange(row) {
            this.$Modal.confirm({
                title: "提示",
                content: `是否确认兑换${row.goods.name}`,
                onOk: () => {
                    let data = {
                        id: row.id,
                        status: row.status,
                    };
                    points_order_status(data)
                        .then((res) => {
                            this.getListOrder();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goDelivery(row) {
            this.deliveryData.id = row.id;
            points_order_info({ id: this.deliveryData.id })
                .then((res) => {
                    this.deliveryData.delivery_info = res.data.delivery_info;
                    this.deliveryData.name = res.data.name;
                    this.deliveryData.phone = res.data.phone;
                    this.deliveryData.address = res.data.address;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
            this.deliveryModal = true;
        },
        goCancelDelivery() {
            this.deliveryModal = false;
        },
        goSubmitDelivery() {
            var data = {
                id: this.deliveryData.id,
                delivery_info: this.deliveryData.delivery_info,
            };
            points_order_delivery(data)
                .then((res) => {
                    this.getListOrder();
                    this.deliveryModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.form-title {
    margin-bottom: 24px;
    color: #484e66;
    font-weight: 600;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page-container {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.footer {
    margin: 24px 0 0 0;
    text-align: right;
}
.form-upload {
    width: 100px;
    height: 100px;
    background-color: #fff;
    border: 1px dashed #9fa5bb;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.form-img {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    position: relative;
}
.wh100 {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.dis-flex {
    display: flex;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.flex-center {
    display: flex;
    align-items: center;
}
.upload-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 12px 12px 0;
}
.upload-del {
    position: absolute;
    top: -6px;
    right: -6px;
    cursor: pointer;
}
.upload-img {
    width: 100px;
    height: 100px;
    border-radius: 5px;
}
::v-deep .ivu-checkbox {
    margin-right: 12px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border: 2px solid #ff761d !important;
}
::v-deep .ivu-radio-inner:after {
    background-color: #fff !important;
    margin-right: 12px;
}
</style>